































































































































































































































































































































































































































































































import BaseCard from '../../_components/BaseCard.vue';
import BaseComponent from '@/core/base.component';
import { Prop, Vue, Component, Watch } from 'vue-property-decorator';
import {
  BrandDto,
  DeliverySpaceDto,
  DeliverySpaceListDto,
  DeliverySpaceUpdateDto,
} from '../../../dto';
import AmenityService from '../../../services/amenity.service';
import DeliverySpaceService from '../../../services/delivery-space.service';
import BrandService from '../../../services/brand.service';
import DeliverySpaceNndOpRecordService from '../../../services/delivery-space-nnd-op-record.service';
import { CONST_YN, Pagination, YN } from '@/common';

import DeliverySpaceUpdate from './DeliverySpaceUpdate.vue';
import DeliverySpaceDetailContractList from './DeliverySpaceDetailContractList.vue';
import toast from '../../../../resources/assets/js/services/toast.js';
import {
  DeliverySpaceNndBrandOpRecordDto,
  DeliverySpaceNndOpRecordDto,
} from '@/dto';
import deliverySpaceNndOpRecordService from '../../../services/delivery-space-nnd-op-record.service';

@Component({
  name: 'DeliverySpaceDetail',
  components: {
    BaseCard,
    DeliverySpaceDetailContractList,
    DeliverySpaceUpdate,
  },
})
export default class DeliverySpaceList extends BaseComponent {
  private deliverySpaceDto = new DeliverySpaceDto();
  private deleteDeliverySpaceConfirm = null;
  private prevNo = null;
  private nextNo = null;

  private deliverySpaceNndOpRecordCreateDto = new DeliverySpaceNndOpRecordDto();
  private opYn: YN[] = [...CONST_YN];
  private brandList: BrandDto[] = [];
  // private brandRecords: DeliverySpaceNndBrandOpRecordDto[] = [];
  private newBrandList = [];
  private selectedBrands = [];

  private opBrandList = [];
  private selectedOpBrands = [];
  private selectedOpRecordId = null;
  private selectedOpBrandId = null;

  // 타입 상세 보기
  findOne(id) {
    if (id !== this.$route.params.id) {
      this.$route.params.id = id;
      this.$router.push(`/company/delivery-space/${this.$route.params.id}`);
    }
    DeliverySpaceService.findOne(this.$route.params.id).subscribe(res => {
      if (res) {
        this.deliverySpaceDto = res.data;
        this.findOnePrevious(id);
        this.findOneNext(id);
        this.$root.$emit('find_contract_list', this.$route.params.id);
      }
    });
  }

  // 이전 타입 보기
  findOnePrevious(id) {
    DeliverySpaceService.findOnePrevious(id).subscribe(res => {
      if (res) {
        this.prevNo = res.data;
      }
    });
  }

  // 다음 타입 보기
  findOneNext(id) {
    DeliverySpaceService.findOneNext(id).subscribe(res => {
      if (res) {
        this.nextNo = res.data;
      }
    });
  }

  onBrandSelected(event, i) {
    console.log('onBrandSelected event', event);
    console.log('onBrandSelected brandNo', i);
    this.newBrandList[i].isSelected = event;
  }

  showUpdateModal() {
    this.$root.$emit('update_delivery_space', this.deliverySpaceDto);
    this.findOne(this.$route.params.id);
  }

  // 직영점 브랜드
  getNndBrand() {
    BrandService.findNanudaBrand().subscribe(res => {
      if (res) {
        this.brandList = res.data;
        this.brandList.map(brand => {
          // const newBrandRecord = new DeliverySpaceNndBrandOpRecordDto();
          const newBrandRecord: any = {};
          newBrandRecord.brandNo = brand.no;
          newBrandRecord.isOperatedYn = YN.NO;
          newBrandRecord.isSelected = false;
          newBrandRecord.brand = brand;
          this.newBrandList.push(newBrandRecord);
        });
      }
    });
  }

  showCreateOPRecordModal() {
    this.getNndBrand();
    this.deliverySpaceNndOpRecordCreateDto = this.deliverySpaceDto;
    this.newBrandList = [];
  }

  onChangeChecked(value, i) {
    this.newBrandList[i].isSelected = value;
  }

  @Watch('newBrandList', {
    deep: true,
  })
  onChangeBrand() {
    this.selectedBrands = [];
    this.newBrandList.map(e => {
      if (e.isSelected) {
        this.selectedBrands.push({
          brandNo: e.brandNo,
          isOperatedYn: e.isOperatedYn,
        });
      }
    });
  }

  createNndOpRecord() {
    this.deliverySpaceNndOpRecordCreateDto.deliverySpaceNndBrandOpRecords = this.selectedBrands;
    DeliverySpaceService.update(
      this.$route.params.id,
      this.deliverySpaceNndOpRecordCreateDto,
    ).subscribe(res => {
      console.log('res', res);
      toast.success('수정완료');
      this.$bvModal.hide('create_nnd_op_record');
      this.findOne(this.$route.params.id);
    });
  }

  // 운영 브랜드 수정

  // onChangeNewChecked(value, i) {
  //   this.opBrandList[i].isSelected = value;
  // }

  // @Watch('opBrandList', {
  //   deep: true,
  // })
  // onChangeOpBrand() {
  //   this.selectedOpBrands = [];
  //   this.selectedOpBrandId = null;
  //   this.opBrandList.map(e => {
  //     if (e.isSelected) {
  //       // this.selectedOpBrands.push({
  //       //   brandNo: e.brandNo,
  //       //   isOperatedYn: e.isOperatedYn,
  //       // });
  //       this.selectedOpBrandId = e.brandNo;
  //     }
  //   });
  // }

  showUpdateNndOpBrand(recordNo, i) {
    this.selectedOpRecordId = recordNo;
    this.opBrandList = this.deliverySpaceDto.nndOpRecord[i].nndBrandOpRecord;
    //클릭한 기록의 운영중인 브랜드로 미리 선택함
    const index = this.opBrandList.findIndex(e => e.isOperatedYn === 'Y');
    this.selectedOpBrandId = this.opBrandList[index].no;
    // DeliverySpaceNndOpRecordService.findforBrand(recordNo).subscribe(res => {
    //   if (res) {
    //     this.selectedOpBrands = res.data;
    //   }
    // });
    // this.opBrandList = [];
    // BrandService.findNanudaBrand().subscribe(res => {
    //   if (res) {
    //     this.brandList = res.data;
    //     this.brandList.map(brand => {
    //       const opBrandRecord: any = {};
    //       opBrandRecord.brandNo = brand.no;
    //       this.selectedOpBrands.map(selectedBrand => {
    //         if (selectedBrand.brandNo === brand.no) {
    //           opBrandRecord.isOperatedYn = selectedBrand.isOperatedYn
    //             ? selectedBrand.isOperatedYn
    //             : 'N';
    //           opBrandRecord.isSelected = true;
    //         }
    //       });
    //       opBrandRecord.brand = brand;
    //       this.opBrandList.push(opBrandRecord);
    //     });
    //   }
    // });
  }

  updateNndOpBrand() {
    DeliverySpaceNndOpRecordService.update(
      this.selectedOpRecordId,
      this.selectedOpBrandId,
    ).subscribe(res => {
      if (res) {
        console.log('res', res);
        toast.success('수정완료');
        this.$bvModal.hide('update_nnd_op_brand');
        this.findOne(this.$route.params.id);
      }
    });
  }

  // 공간 삭제

  deleteDeliverySpace() {
    if (this.deleteDeliverySpaceConfirm === '삭제하겠습니다') {
      DeliverySpaceService.hardDelete(this.$route.params.id).subscribe(res => {
        if (res) {
          this.$router.push('/company/delivery-space');
          toast.success('삭제완료');
        }
      });
    } else {
      toast.error('삭제하겠습니다 입력해주세요');
    }
  }

  created() {
    this.findOne(this.$route.params.id);
  }

  mounted() {
    this.$root.$on('find_delivery_space', () => {
      this.findOne(this.$route.params.id);
    });
    this.$root.$on('delete_contract_list', () => {
      this.findOne(this.$route.params.id);
    });
  }
}
